import { View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { ScrollViewModel } from "./scroll-viewModel"

export class ScrollView extends FormBuilderComponentView<ScrollViewModel>{
    GetViewUniqueId(): string {
        return "V-8E0029F9-600D-45EB-84C5-8673C0B52024"
    }
    loadHtml(): string {
        let element = require('./scroll.html').default;
        let style = require('./scroll.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
    public set AllowHorizontal(v: boolean) { this._AllowHorizontal = v; } public get AllowHorizontal(): boolean { return this._AllowHorizontal;} private _AllowHorizontal: boolean;
    public set AllowVertical(v: boolean) { this._AllowVertical = v; } public get AllowVertical(): boolean { return this._AllowVertical;} private _AllowVertical: boolean;

}
